"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const IdentityInfo_1 = __importDefault(require("./IdentityInfo"));
const constants_1 = require("../constants");
class State {
    constructor(state) {
        this.stateAbbrev = state;
        this.stateFull = constants_1.stateAbbrevToFull[state];
        this.identityInfo = new IdentityInfo_1.default(constants_1.LegislatorTypes.STATE_SUM, state, "", "", "", null, "");
    }
}
exports.default = State;
